import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  UPDATE_COMPETITION,
  GET_COMPETITIONS,
  GET_COMPETITION,
} from "../../GraphQL/Competitions";
import useNotification from "../../hooks/useNotification.js";

const EditCompetitionDialog = (props) => {
  const [competition, setCompetition] = useState(props.competition);
  const { notifySuccess } = useNotification();

  useEffect(() => {
    setCompetition(props.competition);
  }, [props]);

  const isValid = !!(competition?.name?.trim());

  const [updateCompetition, { loading, error }] = useMutation(
    UPDATE_COMPETITION,
    {
      variables: {
        id: props.competition.id,
        name: competition.name,
        description: competition.description,
        url: competition.url,
      },
      refetchQueries: [GET_COMPETITIONS, GET_COMPETITION],
      onCompleted: () => { notifySuccess("Competition updated."); props.setOpen(false); },
    }
  );

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isValid) {
            updateCompetition();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Competition"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TextField
            data-testid="name"
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={props.competition.name}
            onChange={(e) => {
              setCompetition({ ...competition, name: e.target.value });
            }}
            inputProps={{ maxLength: 20 }}
            helperText={`${competition?.name?.length ?? 0}/20`}
          />
          <TextField
            data-testid="description"
            margin="dense"
            id="description"
            label="Description"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={props.competition.description}
            onChange={(e) =>
              setCompetition({ ...competition, description: e.target.value })
            }
            inputProps={{ maxLength: 20 }}
            helperText={`${competition?.description?.length ?? 0}/20`}
          />
          <TextField
            data-testid="url"
            margin="dense"
            id="url"
            label="URL"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={props.competition.url}
            onChange={(e) =>
              setCompetition({ ...competition, url: e.target.value })
            }
            inputProps={{ maxLength: 20 }}
            helperText={`${competition?.url?.length ?? 0}/20`}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveEditCompetitionDialogButton"
            variant="contained"
            onClick={() => updateCompetition()}
            disabled={loading || !isValid}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Update"
            )}
          </Button>
          <Button
            data-testid="closeEditCompetitionDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default EditCompetitionDialog;
